/**
 * Close Time Modal Controller
 *
 * Manages the custom close time override modal
 * @module portal/modules/ui/modals/closeTimeModal
 */

import { state } from '../../state';
import { Lot } from '../../types';
import { getEffectiveCloseTime, hasCustomCloseTime } from '../../storage';
import { els } from '../elements';

const bodyEl = document.body;

/**
 * Check if the close time modal is currently open
 */
export function isCloseTimeModalOpen(): boolean {
  return !!els.closeTimeModal && !els.closeTimeModal.hidden;
}

/**
 * Open the close time override modal
 * @param lot - The lot to set a custom close time for
 */
export function openCloseTimeModal(lot: Lot): void {
  if (!lot || !lot.id) {
    return;
  }

  state.closeTimeEdit = {
    id: lot.id,
  };

  const effectiveCloseAt = getEffectiveCloseTime(lot);
  const hasCustom = hasCustomCloseTime(lot.id);

  if (els.closeTimeValue instanceof HTMLInputElement) {
    if (effectiveCloseAt && Number.isFinite(effectiveCloseAt)) {
      const date = new Date(effectiveCloseAt);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      els.closeTimeValue.value = `${year}-${month}-${day}T${hours}:${minutes}`;
    } else {
      els.closeTimeValue.value = '';
    }
  }

  if (els.closeTimeCustomIndicator) {
    els.closeTimeCustomIndicator.dataset.visible = hasCustom ? 'true' : 'false';
  }

  if (els.closeTimeClear) {
    els.closeTimeClear.hidden = !hasCustom;
  }

  if (els.closeTimeModal) {
    els.closeTimeModal.hidden = false;
  }
  if (els.closeTimeModalBackdrop) {
    els.closeTimeModalBackdrop.hidden = false;
  }
  if (bodyEl) {
    bodyEl.classList.add('modal-open');
  }

  window.requestAnimationFrame(() => {
    if (els.closeTimeValue instanceof HTMLInputElement) {
      els.closeTimeValue.focus();
    }
  });
}

/**
 * Close the close time override modal
 */
export function closeCloseTimeModal(): void {
  if (els.closeTimeModal) {
    els.closeTimeModal.hidden = true;
  }
  if (els.closeTimeModalBackdrop) {
    els.closeTimeModalBackdrop.hidden = true;
  }
  if (bodyEl) {
    bodyEl.classList.remove('modal-open');
  }
  state.closeTimeEdit = null;
}
